import React, { useEffect, useState } from 'react';
import UpdateInvestigation from './index';
import { fetchInvestigation as fetchInvestigationRemote } from '../../../services';

export default function EditInvestigation(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [investigation, setInvestigation] = useState(false);
    const [error, setError] = useState(false);
    useEffect(() => {
        async function fetchInvestigation(){
            try{
                const response = await fetchInvestigationRemote(props.uuid);
                setInvestigation(response.investigation);
                setIsLoading(false);
            }
            catch(error){
                setError(true);
                setIsLoading(false);
            }
        }
        setIsLoading(true);
        fetchInvestigation();
        // SHER-332: depend on props.uuid. React Router reuses this component when only the
        // :uuid route param changes, so without this the editor kept showing the form it
        // first loaded (e.g. open "Test" → it showed "kinesitherapie", the previously loaded one).
    }, [props.uuid])

    return <UpdateInvestigation  uuid={props.uuid}
            initialState={{investigation:investigation, isLoading:isLoading, error : error}} />
}
